import { render, staticRenderFns } from "./AdminNotifications.html?vue&type=template&id=389ad32e&scoped=true&external"
import script from "./AdminNotifications.js?vue&type=script&lang=js&external"
export * from "./AdminNotifications.js?vue&type=script&lang=js&external"
import style0 from "./AdminNotifications.vue?vue&type=style&index=0&id=389ad32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ad32e",
  null
  
)

export default component.exports